import Main from "~/layout/App/Index.vue";

export default {
  path: "/instruction",
  component: Main,
  meta: {
    breadcrumb: [{ name: "breadcrumb.instruction.main", route: "instruction.index" }],
  },
  children: [
    {
      path: "",
      name: "instruction.index",
      component: () => import("~/views/Instruction/Index.vue"),
      meta: {
        breadcrumb: [{ name: "breadcrumb.overview" }],
      }
    }
  ]
}; 